import store from '@store';

export default {
  methods: {
    setBreadcrumb: (breadcrumb = []) => store.dispatch('breadcrumb/set', breadcrumb),
    getData: (key) => store.getters['data/get'](key),
    getUser: () => store.getters['user/get'],
    getCompany: () => store.getters['core-company-menu/companySelected'],
    getCompanies: () => store.getters['core-company-menu/get'],

    hasAlert: () => store.getters['request/hasAlert'],
    getAlert: () => store.getters['request/alert'],
  },
  computed: {
    isMultiCompany: () => store.getters['core-company-menu/isMultiCompany'],
    isIframeV2: () => store.getters['core-iframe/get'],
    isSSOMode: () => store.getters['core-sso/get'],
  },
};
